import {useState} from "react";
import {useLxTranslations} from "@lxo-blocks/react";
import {PASSWORD_INPUT_TRANSLATION} from "./PasswordInput.translation.de";

export enum ValidationState {
  INIT,
  VALID,
  INVALID,
}

export function usePasswordValidation(): any {
  const [isValidPassword, setIsValidPassword] = useState(false);
  const [isPasswordConfirmed, setIsPasswordConfirmed] = useState(false);
  const [currentPassword, setCurrentPassword] = useState<string>("");
  const {t} = useLxTranslations(PASSWORD_INPUT_TRANSLATION);

  const [criterias, setCriterias] = useState({
    length: ValidationState.INIT,
    upperCase: ValidationState.INIT,
    lowerCase: ValidationState.INIT,
    numberSpecialChar: ValidationState.INIT,
  });

  const validateConfirmedPassword = (confirmedPassword: string) => {
    const isConfirmed = (currentPassword === confirmedPassword);
    setIsPasswordConfirmed(isConfirmed);
    return isConfirmed
      ? true : t("ERROR_PASSWORDS_DO_NOT_MATCH");
  };

  const validatePassword = (password: string) => {
    if (currentPassword !== password) {
      setIsPasswordConfirmed(false);
    }
    setCurrentPassword(password);
    const upperCasePattern = /[A-Z]/;
    const lowerCasePattern = /[a-z]/;
    const numberSpecialCharPattern =
      /[0-9`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]+/;

    var criterias = {
      length:
        password.length < 8 ? ValidationState.INVALID : ValidationState.VALID,
      upperCase: !upperCasePattern.test(password)
        ? ValidationState.INVALID
        : ValidationState.VALID,
      lowerCase: !lowerCasePattern.test(password)
        ? ValidationState.INVALID
        : ValidationState.VALID,
      numberSpecialChar: !numberSpecialCharPattern.test(password)
        ? ValidationState.INVALID
        : ValidationState.VALID,
    };

    const isValid =
      criterias.length === ValidationState.VALID &&
      criterias.lowerCase === ValidationState.VALID &&
      criterias.upperCase === ValidationState.VALID &&
      criterias.numberSpecialChar === ValidationState.VALID;

    setCriterias(() => criterias);
    setIsValidPassword(() => isValid);

    return isValid ? true : t("ERROR_PASSWORD_NOT_VALID");
  };


  return {
    criterias: criterias,
    isValidPassword: isValidPassword,
    validatePassword: validatePassword,
    validateConfirmedPassword: validateConfirmedPassword,
    isPasswordConfirmed: isPasswordConfirmed,
    currentPassword: currentPassword
  };
}
